export default class FileExporter {
  async exportFile(callback) {
    const { data: file, headers } = await callback();
    const contentDisposition = headers["content-disposition"];
    const contentType = headers["content-type"];
    const fileName = contentDisposition
      .split("filename=")[1]
      .replace(/['"]+/g, "");

    this.downloadFile(file, fileName, contentType);
  }

  downloadFile(file, fileName, contentType) {
    const url = window.URL.createObjectURL(
      new Blob([file], { type: contentType })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
